// extracted by mini-css-extract-plugin
export default {"form":"_1B14Rgz1cmNuYvritqLs5D","checkboxes":"oftMnRLe1xn9Tuix1pW3b"};